import { IInterval } from "../Context/Interval";
import { ISystemContext } from "../Context/SystemContext";
import { CreateElement, Scale } from "../MyHelpers";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, ResourceManager } from "../ResourceManager/ResourceManager";
import { ZIndex } from "../ZIndex";


export class ReplayMessage
{

    private view: HTMLElement;
    private visible: boolean = false;

    private context: ISystemContext;
    private blinkingTimer: IInterval;
    private blinkingVisible: boolean = false;

    public constructor(context: ISystemContext)
    {
        this.context = context.CreateSubContext("ReplayMessage");
    }

    public PrepareResources(resourceManager: IWriteOnlyResourceManager): void
    {
		this.view = CreateElement("div", {
			classes: ["recoveryMessage"],
			parentToAppend: this.view,
			style: {
				position: "absolute",
				display: "none",
				justifyContent: "center",
				alignItems: "center",
				width: "100%",
				height: "100%",
				fontFamily: "NotoSansDisplay-ExtraBold",
				top:"0px",
				color: "red",
				fontSize: Scale.fhpx(108),
				pointerEvents : "none",
				webkitTextStroke: `${Scale.fhpx(5)} black`,
                zIndex: ZIndex.ReplayMessage.toString(),
			}
		}); 

        this.view.innerHTML = "REPLAY";
		this.visible = false;

        this.blinkingTimer = this.context.TimingContext().CreateInterval("blinkingTimer", 500, this.ToggleBlink.bind(this))
    }

    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager): void
    {

    }


    private RestartBlinking()
    {
        this.view.style.display = "flex";
        this.visible = true;
        this.blinkingTimer.Start();
    }

    private StopBlinking()
    {
        this.blinkingTimer.Stop();
    }

    private ToggleBlink(): void
    {
        if (!this.blinkingVisible)
        {
            // show
            this.view.style.visibility = "";
            this.blinkingVisible = true;
        }
        else
        {
            // hide
            this.view.style.visibility = "hidden";
            this.blinkingVisible = false;
        }
    }

    public Show(): void
    {
        if (this.visible)
        {
            // already visible
            return;
        }

        this.blinkingVisible = true;
        this.view.style.visibility = "";

        this.RestartBlinking();
    }

    public Hide(): void
    {
        if (!this.visible)
        {
            // already hidden
            return;
        }

        this.StopBlinking();

        this.view.style.display = "none";
        this.visible = false;
        
    }

    public View(): HTMLElement
    {
        return this.view;
    }
}